import { render } from "./Residence.vue?vue&type=template&id=c2f4195c&scoped=true"
import script from "./Residence.vue?vue&type=script&lang=js"
export * from "./Residence.vue?vue&type=script&lang=js"

import "./Residence.vue?vue&type=style&index=0&id=c2f4195c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2f4195c"

export default script